import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { DisablePermissionDirective } from './directives/disable-permission.directive';
import { AccessPermissionDirective } from './directives/access-permission.directive';
import { AutoLogOutDialogComponent } from './components/auto-log-out-dialog.component';
import { ApplicationEffects } from './store/ApplicationEffects';
import { KeepDisabledDirective } from './directives/keep-disabled.directive';
import { LookupInputComponent } from './components/lookup-input.component';
import { OptionsScrollDirective } from './directives/options-scroll.directive';
import { FormNativeElementDirective } from './directives/form-native-element.directive';
@NgModule({
  entryComponents: [AutoLogOutDialogComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    EffectsModule.forFeature([ApplicationEffects])
  ],
  declarations: [DisablePermissionDirective, AccessPermissionDirective, AutoLogOutDialogComponent, KeepDisabledDirective, LookupInputComponent, OptionsScrollDirective, FormNativeElementDirective],
  exports: [DisablePermissionDirective, AccessPermissionDirective, KeepDisabledDirective, LookupInputComponent, FormNativeElementDirective]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts